import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const WebhookConfigurations = () =>
  import('@/pages/webhook-management/webhook-configurations/WebhookConfigurations.vue');
const WebhookGuide = () => import('@/pages/webhook-management/webhook-guide/WebhookGuide.vue');
const WebhookEventTypes = () =>
  import('@/pages/webhook-management/webhook-event-types/WebhookEventTypes.vue');
const WebhookPayloads = () =>
  import('@/pages/webhook-management/webhook-payloads/WebhookPayloads.vue');
const WebhookAuthMethods = () =>
  import('@/pages/webhook-management/webhook-auth-methods/WebhookAuthMethods.vue');
const WebhookMonitoring = () =>
  import('@/pages/webhook-management/webhook-monitoring/WebhookMonitoring.vue');
const WebhookTestSendPage = () =>
  import('@/pages/webhook-management/test-send/WebhookTestSendPage.vue');
const CircleKPcsStations = () =>
  import('@/pages/webhook-management/circle-k-pcs-stations/CircleKPcsStations.vue');
const CircleKPcsStationEditPage = () =>
  import('@/pages/webhook-management/circle-k-pcs-stations/edit/CircleKPcsStationEditPage.vue');
const CircleKPcsMonitoring = () =>
  import('@/pages/webhook-management/circle-k-pcs-monitoring/CircleKPcsMonitoring.vue');
const CircleKPcsHowItWorks = () =>
  import('@/pages/webhook-management/circle-k-pcs-how-it-works/CircleKPcsHowItWorks.vue');

/** ryd internal: the Circle K PCS station and monitoring pages (TASKFORCE-3034). */
const PCS_STATIONS_ACCESS = {
  requiresAuth: true,
  requiredUserGroup: ['ryd'],
  requiredRoles: ['bmw_circle_k_pcs'],
};

export const webhookManagementRoutes: AppRouteRecordRaw[] = [
  {
    path: '/webhook-management',
    component: Body,
    meta: {
      breadcrumb: 'Webhook Management',
    },
    children: [
      {
        path: 'configurations',
        name: 'WebhookConfigurations',
        component: WebhookConfigurations,
        meta: {
          title: 'Webhook Configurations | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Configurations',
        },
      },
      {
        path: 'guide',
        name: 'WebhookGuide',
        component: WebhookGuide,
        meta: {
          title: 'Webhook Guide | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhooks',
        },
      },
      {
        path: 'event-types',
        name: 'WebhookEventTypes',
        component: WebhookEventTypes,
        meta: {
          title: 'Webhook Event Types | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Event Types',
        },
      },
      {
        path: 'payloads',
        name: 'WebhookPayloads',
        component: WebhookPayloads,
        meta: {
          title: 'Webhook Payloads | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Payloads',
        },
      },
      {
        path: 'authentication-methods',
        name: 'WebhookAuthMethods',
        component: WebhookAuthMethods,
        meta: {
          title: 'Webhook Authentication Methods | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Authentication Methods',
        },
      },
      {
        path: 'monitoring',
        name: 'WebhookMonitoring',
        component: WebhookMonitoring,
        meta: {
          title: 'Webhook Monitoring | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Monitoring',
        },
      },
      {
        path: 'test-send/:environment/:configId',
        name: 'WebhookTestSend',
        component: WebhookTestSendPage,
        meta: {
          title: 'Webhook Test Send | ryd Portal',
          requiresAuth: true,
          requiredPartnerTypes: ['API_PARTNER'],
          breadcrumb: 'Webhook Test Send',
        },
      },
      {
        path: 'circle-k-pcs-stations',
        name: 'CircleKPcsStations',
        component: CircleKPcsStations,
        meta: {
          ...PCS_STATIONS_ACCESS,
          title: 'Circle K PCS Stations | ryd Portal',
          breadcrumb: 'Circle K PCS Stations',
        },
      },
      {
        path: 'circle-k-pcs-stations/new',
        name: 'CircleKPcsStationCreate',
        component: CircleKPcsStationEditPage,
        meta: {
          ...PCS_STATIONS_ACCESS,
          title: 'Add Circle K PCS Station | ryd Portal',
          breadcrumb: 'Add Circle K PCS Station',
        },
      },
      {
        path: 'circle-k-pcs-stations/edit/:poiId',
        name: 'CircleKPcsStationEdit',
        component: CircleKPcsStationEditPage,
        meta: {
          ...PCS_STATIONS_ACCESS,
          title: 'Edit Circle K PCS Station | ryd Portal',
          breadcrumb: 'Edit Circle K PCS Station',
        },
      },
      {
        path: 'circle-k-pcs-monitoring',
        name: 'CircleKPcsMonitoring',
        component: CircleKPcsMonitoring,
        meta: {
          ...PCS_STATIONS_ACCESS,
          title: 'Circle K PCS Monitoring | ryd Portal',
          breadcrumb: 'Circle K PCS Monitoring',
        },
      },
      {
        path: 'circle-k-pcs-how-it-works',
        name: 'CircleKPcsHowItWorks',
        component: CircleKPcsHowItWorks,
        meta: {
          ...PCS_STATIONS_ACCESS,
          title: 'How Circle K PCS Works | ryd Portal',
          breadcrumb: 'How Circle K PCS Works',
        },
      },
    ],
  },
];
